import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  inject,
  viewChild,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import {
  SendTypes,
  SmsCp,
  SocialMediaSendDetailModel,
  UseTypes,
  UserPrivateNumbersForSendDto,
  VoiceMessageDetailsRequest,
} from 'src/app/core/api/models';
import { AppStateService } from 'src/app/core/services/app-state.service';
import { AppPrivateNumberSelectSearch } from 'src/app/core/types/app-private-number_select-search.type';
import { AppSmsBodyPrivateNumber } from 'src/app/core/types/app-sms-body-private-number.type';
import { AppSmsCp } from 'src/app/core/types/app-sms-cp.type';

@Component({
  selector: 'app-base-sms-body-properties',
  template: ``,
  standalone: false,
})
export class SmsBodyProperties {
  appStateService = inject(AppStateService);

  //#region properties
  readonly smsbodyElement = viewChild<ElementRef>('smsbody');
  readonly backdropElement = viewChild<ElementRef>('backdrop');

  @Input('privateNumberType') input_privateNumberType: AppSmsBodyPrivateNumber =
    'default';
  @Input('form') input_form: FormGroup;
  @Input('groupName') input_formGroupName: string;
  @Input('smsBodyControlName') input_smsBodyControlName: string;
  @Input('senderNumberControlName') input_senderNumberControlName: string;
  @Input('voiceMessageControlName') input_voiceMessageControlName: string;
  @Input('socialMediaMessageControlName')
  input_socialMediaMessageControlName: string;
  @Input('socialMediaApplicationControlName')
  input_socialMediaApplicationControlName: string;
  @Input('maxTryCountControlName') input_maxTryCountControlName: string;
  @Input('minuteBetweenTriesControlName')
  input_minuteBetweenTriesControlName: string;
  @Input('organizationId') input_organizationId: number;
  @Input('userId') input_userId: number;
  @Input('smsBodyRow') input_smsBodyRow: number = 12;
  @Input('isAddSignature') input_isAddSignature: boolean;
  @Input('isAddHeader') input_isAddHeader: boolean;
  @Input('isShowEmojiPicker') input_showEmojiPicker: boolean = true;
  @Input('isShowShortLink') input_showShortLink: boolean = true;
  @Input('isShowSmsTemplate') input_isShowSmsTemplate: boolean = true;
  @Input('isShowSmsPreview') input_isShowSmsPreview: boolean = true;
  @Input('isShowSenderNumberId') input_isShowSenderNumberId: boolean = true;
  @Input('isShowEditorOptions') input_isShowEditorOptions: boolean = true;
  @Input('isReadOnlySmsBody') isReadOnlySmsBody: boolean;
  @Input('sendType') input_sendType: SendTypes;
  @Input('isShowSmsCp') input_isShowSmsCp: boolean = false;
  @Input('useType') input_useType: UseTypes = UseTypes.Normal;
  @Input('smsCp') input_smsCp: SmsCp;
  @Input('disabled') input_disabled: boolean;
  @Input('senderNumberLabel') input_senderNumberLabel: string =
    'common.senderNumberId';
  @Input('voiceMessageLabel') input_voiceMessageLabel: string =
    'common.voiceMessage';
  @Input('socialMediaMessageLabel') input_socialMediaMessageLabel: string =
    'common.socialMediaMessage';
  @Input('input_socialMediaApplicationLabel')
  input_socialMediaApplicationLabel: string = 'common.socialMediaApplication';
  @Input('smsBody') smsBody: string = '';

  //voice section
  @Input('voiceMessageId') voiceMessageId: number;
  @Input('maxTryCount') maxTryCount: number;
  @Input('minuteBetweenTries') minuteBetweenTries: number;

  //media section
  @Input('socialMediaFileId') socialMediaFileId: number;
  @Input('socialMediaFileTitle') socialMediaFileTitle: string = '';
  @Input('socialMediaApplicationId') socialMediaApplicationId: number;
  @Input('socialMediaApplicationName') socialMediaApplicationName: string = '';

  @Input('isSmartSmsTitle') isSmartSmsTitle: boolean = false;
  @Input('senderNumberId') senderNumberId: number;
  @Input('voiceMessageDetails')
  voiceMessageDetails: VoiceMessageDetailsRequest = {};
  @Input('voiceMessageGroupId') voiceMessageGroupId: number;
  @Input('socialMediaMessageDetails')
  socialMediaMessageDetails: SocialMediaSendDetailModel = {};
  @Input('isEditMode') isEditMode: boolean = false;
  @Input('isCanSendVoice') isCanSendVoice: boolean;
  @Input('isCanSendSocialMedia') isCanSendSocialMedia: boolean;
  @Input('isRefreshForm') isRefreshForm: boolean;
  @Input('optionValue') optionValue: string;
  @Input() valueMaxWidth: string = ' ';
  @Input() numbersType: AppPrivateNumberSelectSearch;
  @Input() isSmartSend: boolean;

  @Output('smsBody') output_smsBody = new EventEmitter<string>();
  @Output('finalSmsBody') output_finalSmsBody = new EventEmitter<string>();
  @Output('smsCount') output_smsCount = new EventEmitter<number>();
  @Output('senderNumber') output_senderNumber =
    new EventEmitter<UserPrivateNumbersForSendDto>();
  @Output('senderNumberId') output_senderNumberId = new EventEmitter<number>();
  @Output('voiceMessageDetails') output_VoiceMessageDetails =
    new EventEmitter<VoiceMessageDetailsRequest>();
  @Output('socialMediaMessageDetails') output_socialMediaMessageDetails =
    new EventEmitter<SocialMediaSendDetailModel>();
  @Output('smsPart') output_smsPart = new EventEmitter<number>();

  sendNumberSelected: any;
  isConvertToPersianNums: boolean = false;
  smsCount: number = 0;
  remainingCharUntilNextPart: number = 0;
  smsLength: number = 0;
  signature: string;
  organizationSignature: string;
  isOrganSignatureAtFirst: boolean = false;
  smsHeader: string;
  organizationSmsHeader: string;
  isOrganSmsHeaderAtFirst: boolean = false;
  isShowContainsHeaderOrSign: boolean = false;
  finalSmsBody: string;
  privateNumber: any;
  maxSmsBodyCount = 6600;
  isChangeSmsCount: boolean = false;
  selectedSmsCp: AppSmsCp = 'mci';

  protected onDestroy$ = new Subject<void>();
  selectedKey = 30;

  get smsCp() {
    return SmsCp;
  }
  //#endregion

  constructor() {}
}
